import React from "react";
import { Outlet } from "react-router-dom";

import Header from "./header/header";
import Sidebar from "./sidebar/sidebar";

const Layout = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <div className="fixed w-full flex flex-col z-10">
                <Header />
            </div>

            <div className="flex mt-[70px] h-[calc(100vh-70px)]">
                <div className="w-[250px] bg-gray-100 p-4 max-lg:hidden flex flex-col h-full">
                    <Sidebar />
                </div>

                <div className="flex-1 bg-white overflow-y-auto">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default Layout;